import userInformations from "./userInformations"
export default userInformations;
